export enum EEventName {
  Draft = 'draft',
  HardBouned = 'hardbounced',
  PartlyRejected = 'partlyrejected',
  Rejected = 'rejected',
  Recalled = 'recalled',
  Lost = 'lost',
  Expired = 'expired',
  Deferred = 'deferred',
  Reviewed = 'reviewed',
  Viewed = 'viewed',
  Commented = 'commented',
  Clicked = 'clicked',
  Downloaded = 'downloaded',
  Attachment = 'attachment',
  AttachmentOpened = 'attachmentopened',
  WaitingForSignature = 'waitingforsignature',
  PartlySigned = 'partlysigned',
  Sent = 'sent',
  Sms = 'sms',
  Reminder = 'reminder',
  Video = 'video',
  Paused = 'paused',
  Updated = 'updated',
  Processing = 'processing',
  Importing = 'importing',
  Printed = 'printed',
  Created = 'created',
  Sealed = 'sealed',
  Scheduled = 'scheduled',
  Waiting = 'waiting',
  Archived = 'archived',
  Delivered = 'delivered',
  Approved = 'approved',
  Verified = 'verified',
  Signed = 'signed',
  SignedWithoutVerification = 'signedwithoutverification',
}
